import { Component, OnInit } from '@angular/core';
import { PickingListStorageService, PickingList, Order, Route } from './picking-list-storage.service';
import { MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from 'primeng/select';
import { Table, TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { SidebarModule } from 'primeng/sidebar';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AppTopbar } from '../layout/component/app.topbar';
import { InMemoryStorageService } from '../services/in-memory-storage.service';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { FieldsetModule } from 'primeng/fieldset';
import { FluidModule } from 'primeng/fluid';
import { MessageModule } from 'primeng/message';
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SplitterModule } from 'primeng/splitter';
import { HeaderInfoComponent } from '../item-details/header-info/header-info.component';
import { ItemTableComponent } from '../item-details/item-table/item-table.component';
import { ConfirmationService } from 'primeng/api';
import { RoleAccessService } from '../auth/role-access.service';
import { AppFeature } from '../auth/features.enum';
import { ViewChild, ElementRef } from '@angular/core';
import { UserRole } from '../auth/roles.enum';
import { LoaderService } from '../services/loader.service';
import { CustomizePickingListService } from '../services/customize-picking-list.service';
@Component({
    imports: [
        SidebarModule,
        DropdownModule,
        AutoCompleteModule,
        CalendarModule,
        DatePickerModule,
        RouterModule,
        CommonModule,
        TableModule,
        FormsModule,
        ButtonModule,
        ContextMenuModule,
        RippleModule,
        ToastModule,
        ToolbarModule,
        RatingModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        RadioButtonModule,
        InputNumberModule,
        DialogModule,
        TagModule,
        InputIconModule,
        IconFieldModule,
        ConfirmDialogModule,
        TooltipModule,
        ProgressSpinnerModule,
        ToastModule,
        FluidModule,
        DividerModule,
        MessageModule,
        RouterModule,
        FormsModule,
        AutoCompleteModule,
        CommonModule,
        TableModule,
        FieldsetModule,
        PanelModule,
        SplitterModule,
        FormsModule,
        ButtonModule,
        CardModule,
        ContextMenuModule,
        RippleModule,
        ToastModule,
        ToolbarModule,
        RatingModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        RadioButtonModule,
        InputNumberModule,
        DialogModule,
        TagModule,
        InputIconModule,
        IconFieldModule,
        ConfirmDialogModule
    ],
    selector: 'app-customize-picking-list',
    templateUrl: './customize-picking-list.component.html',
    styleUrls: ['./customize-picking-list.component.scss'],
    providers: [MessageService, ConfirmationService]
})
export class CustomizePickingListComponent implements OnInit {
    isReadOnly: boolean = false;
    userRoles: UserRole[] = [];
    // Dialog visibility flags
    showAddDriverDialog = false;
    showAddVehicleDialog = false;
    @ViewChild('recentPicklistsSection') recentPicklistsSection!: ElementRef;
    // New driver and vehicle models
    newDriver = { driverName: '' };
    newVehicle = { vehicleNumber: '' };
    scrollToRecentPicklists() {
        if (this.recentPicklistsSection) {
            this.recentPicklistsSection.nativeElement.scrollIntoView({ behavior: 'smooth' });
        }
    }
    // Create Driver API call
    createDriver() {
        const trimmedName = this.newDriver.driverName.trim().toLowerCase();
        const exists = this.driverNumbers.some((d) => d.label.trim().toLowerCase() === trimmedName);
        if (exists) {
            this.messageService.add({
                severity: 'error',
                summary: 'Duplicate Driver',
                detail: 'Driver name already exists.',
                life: 2000
            });
            return;
        }

        this.loaderService.show('creating Driver...', 'Please wait while the driver is being created.');
        this.customizePickingListService.createDriver(this.newDriver.driverName, this.companyId, this.divisionId).subscribe({
            next: () => {
                this.loaderService.hide();
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Driver created successfully.', life: 2000 });
                this.showAddDriverDialog = false;
                this.newDriver = { driverName: '' };
                this.fetchDrivers();
            },
            error: () => {
                this.loaderService.hide();
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create driver.', life: 2000 });
            }
        });
    }

    // Create Vehicle API call
    createVehicle() {
        const trimmedNumber = this.newVehicle.vehicleNumber.trim().toLowerCase();
        const exists = this.vehicleNumbers.some((v) => v.label.trim().toLowerCase() === trimmedNumber);
        if (exists) {
            this.messageService.add({
                severity: 'error',
                summary: 'Duplicate Vehicle',
                detail: 'Vehicle number already exists.',
                life: 2000
            });
            return;
        }

        this.loaderService.show('Creating Vehicle...', 'Please wait while the vehicle is being created.');
        this.customizePickingListService.createVehicle(this.newVehicle.vehicleNumber, this.companyId, this.divisionId).subscribe({
            next: () => {
                this.loaderService.hide();
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Vehicle created successfully.', life: 2000 });
                this.showAddVehicleDialog = false;
                this.newVehicle = { vehicleNumber: '' };
                this.fetchVehicles();
            },
            error: (err) => {
                console.log(err);

                this.loaderService.hide();
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create vehicle.', life: 2000 });
            }
        });
    }
    // Dispatched = orders in picking lists for today
    onDateChange() {
        this.fetchOrdersData();
    }
    selectedDriver: any = null; // Add this line
    selectedVehicle: any = null;
    orders: Order[] = [];
    routes: Route[] = [];
    selectedOrders: Order[] = [];
    showDialog = false;
    vehicleNo = '';
    driverNo = '';
    addOrdersDialogVisible = false;
    ordersToAdd: Order[] = [];
    selectedOrdersToAdd: Order[] = [];

    recentPickingLists: any[] = [];
    recentPickingListsUpdate: any[] = [];

    selectedRouteId: string | null = null;
    selectedPickingList: any = null;
    showPickingListPanel = false;

    selectedPicklistForAdd: any = null;
    selectedOrderIndex: number | null = null;
    isSidebarPinned: boolean = false;
    vehicleNumbers: any[] = [];
    filteredVehicleNumbers: any[] = [];
    driverNumbers: any[] = [];
    filteredDriverNumbers: any[] = [];
    fromDate: string = '';
    toDate: string = '';
    fromDatePKL: string = '';
    toDatePKL: string = '';
    canAccess = false;
    todayDate: string = new Date().toISOString().slice(0, 10);

    constructor(
        private roleAccessService: RoleAccessService,
        private storage: PickingListStorageService,
        private messageService: MessageService,
        private http: HttpClient,
        private confirmationService: ConfirmationService,
        // private router: RouterModule,
        private router: Router,
        private customizePickingListService: CustomizePickingListService,
        private loaderService: LoaderService,
        private inMemoryStorage: InMemoryStorageService // <-- Add this
    ) {}
    companyId: string = '';
    divisionId: string = '';

    ngOnInit() {
        this.userRoles = JSON.parse(this.inMemoryStorage.get('roleGroup') || '[]') as UserRole[];
        console.log('PICKING LIST User Roles:', this.userRoles);

        this.isReadOnly = this.roleAccessService.isReadOnly(this.userRoles);
        console.log('PICKING LIST Is ReadOnly:', this.isReadOnly);

        this.canAccess = this.roleAccessService.hasAccess(this.userRoles, AppFeature.RootwisePickingList);
        console.log('Can Access Rootwise Picking List:', this.canAccess);

        if (!this.canAccess) {
            console.log('User does not have access to Rootwise Picking List');
            this.router.navigate(['/Orders1']);
            return;
        }

        this.companyId = this.inMemoryStorage.get('companyId') || '';
        this.divisionId = this.inMemoryStorage.get('divisionId') || '';
        console.log(`Company ID: ${this.companyId}, Division ID: ${this.divisionId}`);

        // Set default date range: last 7 days
        const today = new Date();
        const lastWeek = new Date();
        lastWeek.setDate(today.getDate() - 6);

        this.fromDate = lastWeek.toISOString().slice(0, 10);
        this.toDate = today.toISOString().slice(0, 10);
        this.fromDatePKL = lastWeek.toISOString().slice(0, 10);
        this.toDatePKL = today.toISOString().slice(0, 10);
        this.fetchOrdersData();
        this.fetchRecentPickingLists();
        this.fetchDrivers();
        this.fetchVehicles();
    }
    fetchDrivers() {
        this.customizePickingListService.getDrivers(this.companyId, this.divisionId).subscribe({
            next: (drivers) => {
                // Show only name in label, value is still ID
                this.driverNumbers = drivers.map((d) => ({
                    label: d.driverName, // Only name shown
                    value: d.driverId
                }));
                this.filteredDriverNumbers = this.driverNumbers;
            },
            error: () => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch drivers.', life: 2000 });
            }
        });
    }

    fetchVehicles() {
        this.customizePickingListService.getVehicles(this.companyId, this.divisionId).subscribe({
            next: (vehicles) => {
                // Show only name in label, value is still ID
                this.vehicleNumbers = vehicles.map((v) => ({
                    label: v.vehicleNumber, // Only name shown
                    value: v.vehicleId
                }));
                this.filteredVehicleNumbers = this.vehicleNumbers;
                console.log('Fetched Vehicles:', this.vehicleNumbers);
            },
            error: () => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch vehicles.', life: 2000 });
            }
        });
    }

    filterVehicleNumbers(event: any) {
        const query = event.query ? event.query.toLowerCase() : '';
        this.filteredVehicleNumbers = this.vehicleNumbers.filter((v) => v.label.toLowerCase().includes(query));
    }

    filterDriverNumbers(event: any) {
        const query = event.query ? event.query.toLowerCase() : '';
        this.filteredDriverNumbers = this.driverNumbers.filter((d) => d.label.toLowerCase().includes(query));
    }
    onDateChangePKL() {
        this.fetchRecentPickingLists();
    }
    fetchOrdersData() {
        this.loaderService.show('Loading Orders...', 'Please wait while orders are fetched.');
        this.customizePickingListService.getOrders(this.companyId, this.divisionId, this.fromDate, this.toDate, 'CRT').subscribe({
            next: (orders: Order[]) => {
                this.orders = orders.map((order: Order) => {
                    const customAddr = (order.customAddress || '').trim();
                    const customerAddress = order.isCustom === 1 && customAddr ? customAddr : order.customerAddress;
                    return {
                        ...order,
                        customerAddress
                    };
                });

                this.loaderService.hide();
            },
            error: () => {
                this.orders = [];
                this.loaderService.hide();
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch orders.', life: 2000 });
            }
        });
    }
    onSidebarCancel() {
        if (!this.isSidebarPinned) {
            this.showPickingListPanel = false;
            this.selectedOrderIndex = null;
            this.selectedPickingList = null;
        }
    }
    selectOrderLine(index: number) {
        this.selectedOrderIndex = this.selectedOrderIndex === index ? null : index;
    }
    toggleSidebarPin() {
        this.isSidebarPinned = !this.isSidebarPinned;
        if (!this.isSidebarPinned) {
            this.showPickingListPanel = false;
            this.selectedOrderIndex = null;
        }
    }
    isOrderSelectable(row: { data: Order; index: number }): boolean {
        return row.data.dispatchStatus !== 'Dispatched';
    }

    openDialog() {
        this.vehicleNo = '';
        this.driverNo = '';
        this.showDialog = true;
    }

    // createPickingList() {
    //     if (!this.vehicleNo || !this.driverNo || !this.selectedOrders.length) return;
    //     this.loading = true;

    //     this.storage.savePickingList({
    //       vehicleNo: this.vehicleNo,
    //       driverNo: this.driverNo,
    //       orders: this.selectedOrders,
    //       createdAt: new Date(),

    //     });

    //     // Remove dispatched orders from the table
    //     const dispatchedIds = this.selectedOrders.map(o => o.orderId);
    //     this.orders = this.orders.filter(order => !dispatchedIds.includes(order.orderId));

    //     this.showDialog = false;
    //     this.loading = false;
    //     this.selectedOrders = [];
    //     this.vehicleNo = '';
    //     this.driverNo = '';
    //     this.messageService.add({severity: 'success', summary: 'Success', detail: 'Picking List Created'});
    //     this.loadRecent();
    //   }

    getOrderNames(orders: any[]) {
        // Use customerName for display
        return orders.map((o) => o.customerName).join(', ');
    }

    get dispatchedOrdersCount(): number {
        // If you want to count dispatched orders, you need to keep track elsewhere,
        // since dispatched orders are removed from this.orders.
        // For now, this will always be 0.
        return 0;
    }

    pickingListDialogVisible = false; // Add this property if not present

    onPickingListClick(list: any) {
        console.log('Picking List clicked:', list);
        this.loaderService.show('Loading Picking List Details...', 'Please wait while picking list details are fetched.');
        // Call API to get picking list details by pklId
        this.customizePickingListService.getPickingListDetails(list.pklId).subscribe({
            next: (details) => {
                console.log('Picking List details:', details);
                console.log('Orders in Picking List:', details.orderHeaders);
                console.log('Orders in Picking List:', details.orderHeaders.length);

                this.selectedPickingList = {
                    ...list,
                    orders: details.orderHeaders || []
                };
                this.pickingListDialogVisible = true; // Show the dialog popup
                this.loaderService.hide();
                console.log('Selected Picking List:', this.selectedPickingList);
                console.log('Selected Picking List:', this.selectedPickingList.orders?.length);
            },
            error: () => {
                this.loaderService.hide();
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch picking list details.', life: 2000 });
            }
        });
    }
    expandAll() {
        if (this.selectedPickingList?.orders) {
            this.selectedPickingList.orders.forEach((order: { expanded: boolean }) => (order.expanded = true));
        }
    }

    collapseAll() {
        if (this.selectedPickingList?.orders) {
            this.selectedPickingList.orders.forEach((order: { expanded: boolean }) => (order.expanded = false));
        }
    }

    get today(): string {
        // Format: yyyy-mm-dd
        return new Date().toISOString().slice(0, 10);
    }
    get totalOrdersToday(): number {
        // Orders created today (in picking lists)
        return this.recentPickingLists.filter((l) => this.isToday(l.createdAt)).reduce((sum, l) => sum + (l.orders?.length || 0), 0);
    }

    get totalDispatchedToday(): number {
        // Dispatched = orders in picking lists for today
        return this.totalOrdersToday;
    }

    get totalRemaining(): number {
        // Orders still in the table
        return this.orders.length;
    }

    isToday(date: Date | string): boolean {
        const d = new Date(date);
        return d.toISOString().slice(0, 10) === this.today;
    }
    createPickingList() {
        // Find selected vehicle and driver objects by name
        const selectedVehicleObj = this.vehicleNumbers.find((v) => v.label === this.selectedVehicle);
        const selectedDriverObj = this.driverNumbers.find((d) => d.label === this.selectedDriver);
        const vehicleId = selectedVehicleObj ? selectedVehicleObj.value : '';
        const driverId = selectedDriverObj ? selectedDriverObj.value : '';

        if (!vehicleId || !driverId || !this.selectedOrders.length) return;

        this.loaderService.show('Creating Picking List...', 'Please wait while your picking list is created.');

        this.customizePickingListService
            .createPickingList(
                this.companyId,
                this.divisionId,
                this.fromDate,
                this.toDate,
                driverId,
                vehicleId,
                this.selectedOrders.map((o) => o.orderId)
            )
            .subscribe({
                next: (response) => {
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Picking List Created', life: 2000 });
                    this.showDialog = false;
                    this.loaderService.hide();
                    this.selectedOrders = [];
                    this.selectedVehicle = '';
                    this.selectedDriver = '';
                    this.fetchRecentPickingLists();
                    this.fetchOrdersData();
                },
                error: (err) => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create picking list.', life: 2000 });
                    this.loaderService.hide();
                }
            });
    }
    fetchRecentPickingLists() {
        this.loaderService.show('Loading Recent Picking Lists...', 'Please wait while picking lists are fetched.');
        this.customizePickingListService.getRecentPickingLists(this.companyId, this.divisionId, this.fromDatePKL, this.toDatePKL).subscribe({
            next: (lists) => {
                this.recentPickingLists = lists.map((list, idx) => ({
                    code: list.pklNumber,
                    vehicleNo: list.vehicle?.vehicleNumber || '',
                    driverNo: list.driver?.driverName || '',
                    fromDate: list.fromDate,
                    toDate: list.toDate,
                    creationDate: list.creationDate,
                    createdAt: list.fromDate, // or use another field if available
                    orders: list.orders || [], // If orders exist in response
                    pklId: list.pklId
                }));
                this.loaderService.hide();
            },
            error: () => {
                this.recentPickingLists = [];
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch recent picking lists.', life: 2000 });
                this.loaderService.hide();
            }
        });
    }
    addToExistingDialogVisible = false;
    fetchPickingListsByDate() {
        console.log('addToExistingDialogVisible:', this.addToExistingDialogVisible);

        // this.pickingListDialogVisible = false; // Hide details dialog
        this.loaderService.show('Loading Picking Lists for Selected Date Range...', 'Please wait while picking lists are fetched.');
        // Calculate date range
        const today = new Date();
        const fromDate = new Date(today);
        fromDate.setDate(today.getDate() - 3);

        const toDate = new Date(today);
        toDate.setDate(today.getDate() + 3);

        // Convert to YYYY-MM-DD format
        const formatDate = (date: Date) => date.toISOString().split('T')[0];
        this.customizePickingListService.fetchPickingListsByDate(this.companyId, this.divisionId, formatDate(fromDate), formatDate(toDate)).subscribe({
            next: (lists) => {
                this.recentPickingListsUpdate = lists.map((list, idx) => ({
                    code: list.pklNumber,
                    vehicleNo: list.vehicle?.vehicleNumber || '',
                    driverNo: list.driver?.driverName || '',
                    fromDate: list.fromDate,
                    toDate: list.toDate,
                    createdAt: list.fromDate,
                    orders: list.orders || [],
                    pklId: list.pklId
                }));

                this.addToExistingDialogVisible = true;

                this.loaderService.hide();
            },
            error: () => {
                this.recentPickingListsUpdate = [];
                this.loaderService.hide();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load picking lists.',
                    life: 2000
                });
            }
        });
    }

    printPickingList(list: any) {
        // Simple print logic: open a new window with order details
        const printContent = `
    <h2>Picking List</h2>
    <b>Vehicle No:</b> ${list.vehicleNo}<br>
    <b>Driver No:</b> ${list.driverNo}<br>
    <b>Created At:</b> ${new Date(list.createdAt).toLocaleString()}<br>
    <hr>
    ${list.orders
        .map(
            (order: any) => `
      <div>
        <b>Order No:</b> ${order.orderNumber}<br>
        <b>Customer Name:</b> ${order.customerName}<br>
        <b>Customer Address:</b> ${order.customerAddress}<br>
        <b>Phone:</b> ${order.phoneNumber}<br>
        <hr>
      </div>
    `
        )
        .join('')}
  `;
        const printWindow = window.open('', '', 'height=600,width=800');
        if (printWindow) {
            printWindow.document.write('<html><head><title>Picking List</title></head><body>');
            printWindow.document.write(printContent);
            printWindow.document.write('</body></html>');
            printWindow.document.close();
            printWindow.print();
        }
    }
    deletePickingList(index: number) {
        this.loaderService.show('Deleting Picking List...', 'Please wait while the picking list is deleted.');
        // Get the picking list to be deleted
        const deletedList = this.recentPickingLists[index];
        if (!deletedList || !deletedList.pklId) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid picking list.', life: 2000 });
            return;
        }
        this.customizePickingListService.deletePickingList(this.companyId, this.divisionId, deletedList.pklId).subscribe({
            next: () => {
                // Restore all its orders to the main table
                if (Array.isArray(deletedList.orders)) {
                    deletedList.orders.forEach((order: Order) => {
                        order.dispatchStatus = 'Pending'; // Reset status if needed
                        this.orders.push(order);
                    });
                }
                this.loaderService.hide();
                // Remove the picking list
                this.recentPickingLists.splice(index, 1);
                this.messageService.add({ severity: 'success', summary: 'Deleted', detail: 'Picking List deleted and orders restored.', life: 2000 });
            },
            error: () => {
                this.loaderService.hide();
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete picking list from server.', life: 2000 });
            }
        });
    }
    cancelOrderFromPickingList(order: Order, index: number) {
        this.selectedPickingList.orders.splice(index, 1);
        order.dispatchStatus = 'Pending';
        this.orders = [...this.orders, order];

        // If no orders left, remove the picking list
        if (this.selectedPickingList.orders.length === 0) {
            const idx = this.recentPickingLists.findIndex((l) => l === this.selectedPickingList);
            if (idx > -1) {
                this.recentPickingLists.splice(idx, 1);
                this.showPickingListPanel = false;
            }
        }

        this.messageService.add({
            severity: 'info',
            summary: 'Order Cancelled',
            detail: `Order ${order.orderNumber} is back in the list.`
        });
    }
    openAddOrdersDialog() {
        // Only show orders not already in any picking list
        const pickedOrderIds = this.recentPickingLists.flatMap((l) => l.orders.map((o: Order) => o.orderId));
        this.ordersToAdd = this.orders.filter((order) => !pickedOrderIds.includes(order.orderId));
        this.selectedOrdersToAdd = [];
        this.addOrdersDialogVisible = true;
    }

    addOrdersToPickingList() {
        if (!this.selectedPickingList) return;
        // Add selected orders to the picking list
        this.selectedPickingList.orders.push(...this.selectedOrdersToAdd);
        // Remove added orders from main table
        const addedIds = this.selectedOrdersToAdd.map((o) => o.orderId);
        this.orders = this.orders.filter((order) => !addedIds.includes(order.orderId));
        this.addOrdersDialogVisible = false;
        this.messageService.add({ severity: 'success', summary: 'Orders Added', detail: 'Orders added to picking list.', life: 2000 });
    }
    // openAddToExistingDialog() {
    //     this.selectedPicklistForAdd = null;
    //     this.addToExistingDialogVisible = true;
    // }
    addSelectedOrdersToPicklist() {
        if (!this.selectedPicklistForAdd || !this.selectedOrders.length) return;

        this.loaderService.show('Adding Orders to Picking List...', 'Please wait while orders are added to the picking list.');

        // Merge existing + new order IDs
        const allOrderIds = Array.from(new Set([...this.selectedPicklistForAdd.orders.map((o: Order) => o.orderId), ...this.selectedOrders.map((o: Order) => o.orderId)]));

        // 🔑 Resolve driverId and vehicleId from dropdowns
        const selectedVehicleObj = this.vehicleNumbers.find((v) => v.label === this.selectedPicklistForAdd.vehicleNo);
        const selectedDriverObj = this.driverNumbers.find((d) => d.label === this.selectedPicklistForAdd.driverNo);

        const vehicleId = selectedVehicleObj ? selectedVehicleObj.value : '';
        const driverId = selectedDriverObj ? selectedDriverObj.value : '';

        if (!vehicleId || !driverId) {
            this.loaderService.hide();
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Vehicle or Driver not found.',
                life: 2000
            });
            return;
        }

        const body = {
            pklId: this.selectedPicklistForAdd.pklId,
            fromDate: this.selectedPicklistForAdd.fromDate,
            toDate: this.selectedPicklistForAdd.toDate,
            status: this.selectedPicklistForAdd.status || '20',
            driverId: driverId, // ✅ Send ID not name
            vehicleId: vehicleId, // ✅ Send ID not name
            orderNumbers: allOrderIds,
            routeId: this.selectedPicklistForAdd.routeId || 0
        };

        this.customizePickingListService.updatePickingList(this.companyId, this.divisionId, body).subscribe({
            next: () => {
                // Update local state
                this.selectedPicklistForAdd.orders.push(...this.selectedOrders);
                const addedIds = this.selectedOrders.map((o) => o.orderId);
                this.orders = this.orders.filter((order) => !addedIds.includes(order.orderId));
                this.selectedOrders = [];
                this.loaderService.hide();
                this.addToExistingDialogVisible = false;
                this.fetchOrdersData();
                this.messageService.add({
                    severity: 'success',
                    summary: 'Orders Added',
                    detail: 'Orders added to existing picking list.',
                    life: 2000
                });
            },
            error: () => {
                this.loaderService.hide();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update picking list.',
                    life: 2000
                });
            }
        });
    }
    refreshOrders() {
        this.fetchOrdersData();
        this.messageService.add({ severity: 'info', summary: 'Orders Refreshed', life: 2000 });
    }

    refreshPickingLists() {
        this.fetchRecentPickingLists();
        this.messageService.add({ severity: 'info', summary: 'Picking Lists Refreshed', life: 2000 });
    }

    goBack() {
        window.history.back();
    }
    deletePickingListLine(order: Order) {
        console.log('Deleting order from picking list:', order);

        if (!order.pkllId) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid picking line.', life: 2000 });
            return;
        }
        this.loaderService.show('Deleting Order from Picking List...', 'Please wait while the order is removed from the picking list.');
        this.customizePickingListService.deletePickingListLine(Number(order.pkllId), this.companyId, this.divisionId).subscribe({
            next: () => {
                // Remove order from sidebar list
                const idx = this.selectedPickingList.orders.findIndex((o: Order) => o.pkllId === order.pkllId);
                if (idx > -1) {
                    this.selectedPickingList.orders.splice(idx, 1);
                }
                this.messageService.add({ severity: 'success', summary: 'Deleted', detail: 'Order removed from picking list.', life: 2000 });
                this.loaderService.hide();
            },
            error: () => {
                this.loaderService.hide();
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete order from picking list.', life: 2000 });
            }
        });
    }
    openCustomizeRouteWisePickingList(list: any) {
        this.router.navigate(['/customize-route-wise-pickinglist'], {
            state: { pickingList: list }
        });
    }
    onGlobalFilter(table: Table, event: Event) {
        table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
    }
    confirmDeletePickingList(rowIndex: number) {
        this.confirmationService.confirm({
            header: 'Delete Confirmation',
            message: 'Are you sure you want to delete this picking list?',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            acceptButtonStyleClass: 'p-button-danger',
            rejectButtonStyleClass: 'p-button-secondary',
            accept: () => {
                this.deletePickingList(rowIndex);
                setTimeout(() => {
                    this.fetchOrdersData();
                }, 1000);
            }
        });
    }
    confirmDeletePickingListLine(order: Order) {
        this.confirmationService.confirm({
            header: 'Delete Confirmation',
            message: 'Are you sure you want to delete this picking list line?',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            acceptButtonStyleClass: 'p-button-danger',
            rejectButtonStyleClass: 'p-button-secondary',
            accept: () => {
                this.deletePickingListLine(order);
                setTimeout(() => {
                    this.fetchOrdersData();
                }, 1000);
            }
        });
    }
}
